import React, { useEffect, useState, useRef } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile'
import { TabMenu } from 'primereact/tabmenu';
import { Image } from 'primereact/image';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { SelectButton } from 'primereact/selectbutton';
import { Divider } from 'primereact/divider';
import { Dialog } from 'primereact/dialog';

// import MessageBox from 'components/MessageBox';

import { socket } from 'lib/socket';
import functions from 'lib/functions';
// import fetchApi from 'lib/fetchApi';

const turnstileSiteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
const genders = [
  { name: '男', value: 1 },
  { name: '女', value: 0 },
];
const menuItems = [
    { label: '訪客', icon: 'pi pi-comments' },
    { label: '會員', icon: 'pi pi-users' },
];

const Home = (props) => {
  const navigate = useNavigate();
  const [menuActiveItem, setMenuActiveItem] = useState(0);
  const [enterData, setEnterData] = useState({ chatter_id: '', nickname: '', gender: 1 });
  const [entering, setEntering] = useState(false);
  const [enterButtontext, setEnterButtontext] = useState('進入聊天室');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVisible, setAlertVisible] = useState(false);

  const [turnstileToken, setTurnstileToken] = useState('');
  const turnstileRef = useRef(null);

  useEffect(() => {
    functions.setBodyPage('home');
  }, []);

  useEffect(() => {
    const isTimeout = functions.getUrlAttr('timeout');
    if (isTimeout === '1') {
      setAlertMessage('你因閒置太久而被登出。');
      setAlertVisible(true);
    }
  }, []);

  useEffect(() => {
    Cookies.remove('chatter');
  }, []);

  // socket
  useEffect(() => {
    if (!socket.connected) {
      socket.connect();
    }
  }, []);

  useEffect(() => {
    socket.on('enterResponse', enterResponse);
    return () => { socket.off('enterResponse', enterResponse); };
  }, []);

  const updateEnterData = (field, value) => {
    setEnterData({
      ...enterData,
      [field]: value
    });
  };

  const enter = () => {
    // check recaptcha
    if (turnstileToken === '') {
      setAlertMessage('必須通過安全驗證。');
      setAlertVisible(true);
      return false;
    }
    if (enterData.nickname.trim() === '') {
      setAlertMessage('必須輸入你的暱稱。');
      setAlertVisible(true);
      return false;
    }
    setEnterButtontext('進入聊天室（登入中⋯）');
    setEntering(true);
    // entering
    // const chatter_id = enterData.chatter_id; // for debug
    const chatter_id = functions.getUUID();
    socket.emit('enter', {
      ...enterData,
      turnstile_token: turnstileToken,
      chatter_id: chatter_id
    });
  };

  const enterResponse = (m) => {
    if (!m.state) {
      var errorMessage = '未知的錯誤，請稍後重試。';
      switch (m.error) {
        case 'invalid_character': errorMessage = '請使用中文、英文及數字作為暱稱。'; break;
        case 'invalid_length': errorMessage = '暱稱長度須在2-20個字元之間。'; break;
        case 'turnstile_error': errorMessage = '安全驗證失敗，請重試。'; break;
        case 'reach_ip_limit': errorMessage = '這個 IP 已達用戶上限。'; break;
        case 'same_nickname': errorMessage = '這個暱稱已被使用。'; break;
      }
      setAlertMessage(errorMessage);
      setAlertVisible(true);
      turnstileRef.current?.reset();
      setEnterButtontext('進入聊天室');
      setEntering(false);
      return false;
    } else {
      Cookies.set('chatter', JSON.stringify(m.data.chatter));
      navigate('/chat');
    }
  };

  return (
    <>
      <div className="flex justify-content-center align-items-center gap-2">
        <Image src="/avatar/1.jpg" height="40" imageClassName="border-round-md" />
        <h1 className="text-indigo-600 lxgw-wenkai-mono-tc-regular font-bold">
          <span style={{color:'#d4a461'}}>三</span>
          <span style={{color:'#c2c2c2'}}>色</span>
          <span style={{color:'#666461'}}>貓</span>
          <span style={{color:'#000'}}>聊</span>
          <span style={{color:'#000'}}>天</span>
          <span style={{color:'#000'}}>室</span>
          </h1>
        <Image src="/avatar/0.jpg" height="40" imageClassName="border-round-md" />
      </div>
      <div className="flex flex-column h-full justify-content-start align-items-center px-3">
        <div className="flex flex-column align-items-center w-12 md:w-4">
          <TabMenu model={menuItems} activeIndex={menuActiveItem} onTabChange={(e) => setMenuActiveItem(e.index)} pt={{
            root: { className: 'w-full' },
            menu: { className: 'flex w-full' },
            menuitem: { className: 'flex flex-1' },
            action: { className: 'flex justify-content-center w-full' },
          }}/>

          {menuActiveItem===0 ?
          <div className="flex flex-column justify-content-start align-items-center w-full py-5 surface-50">
            {/* <div className="mb-2">
              chatter_id (for debug)
            </div>
            <div className="mb-2">
              <InputText className="p-inputtext-sm" value={enterData.chatter_id} onChange={(e) => updateEnterData('chatter_id', e.target.value)} readOnly={entering} maxLength="20" />
            </div> */}
            <div className="mb-2">
              你的稱呼
            </div>
            <div className="mb-2">
              <InputText className="p-inputtext-sm" value={enterData.nickname} onChange={(e) => updateEnterData('nickname', e.target.value)} readOnly={entering} maxLength="20" />
            </div>
            <div className="mb-2">
              你的性別
            </div>
            <div className="mb-3">
              <SelectButton pt={{ button: { className: 'p-button-sm px-3 py-2' }}} value={enterData.gender} onChange={(e) => updateEnterData('gender', e.value)} optionLabel="name" allowEmpty={false} options={genders} disabled={entering} />
            </div>
            <div>
              <Button className="button-xs" label={enterButtontext} onClick={enter} disabled={entering} />
            </div>
          </div>
          :
          <div className="flex flex-column justify-content-start align-items-center w-full py-5 surface-50">
            <div>📣 即將開放會員登記</div>
          </div>
          }
          <div className="flex flex-column justify-content-start align-items-center w-full pb-4 border-round-bottom-2xl surface-50">
            <div className="mb-2">
              安全驗證
            </div>
            <div className="mb-3">
              <Turnstile
                ref={turnstileRef}
                siteKey={turnstileSiteKey}
                onSuccess={(token) => {
                  setTurnstileToken(token);
                }}
                onError={(error) => console.error('Turnstile error:', error)}
                onExpire={() => {
                  setTurnstileToken(null);
                  // setMessage('驗證已過期，請重新提交');
                }}
                theme="auto"
                language="zh-TW"
              />
            </div>
            <div className="text-xs">
              v{process.env.REACT_APP_MODE}
            </div>
          </div>
        </div>
      </div>

      <Dialog header={'⚠️ 錯誤'} visible={alertVisible} style={{ width: 'calc(100% - 40px)', maxWidth: '400px' }} onHide={() => {if (!alertVisible) return; setAlertVisible(false); }}>
        <p className="m-0">{alertMessage}</p>
      </Dialog>

    </>
  );
};
  
export default Home;
